export enum Order {
  ASC = "ASC",
  DESC = "DESC",
}

export interface PageOptions {
  order: Order;
  page: number;
  pageSize: number;
}
